import { render, staticRenderFns } from "./PlayerView.vue?vue&type=template&id=206c28a4&scoped=true&"
import script from "./PlayerView.vue?vue&type=script&lang=js&"
export * from "./PlayerView.vue?vue&type=script&lang=js&"
import style0 from "./PlayerView.vue?vue&type=style&index=0&id=206c28a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c28a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/workspace/is_minesweeper-flags-client_main/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VBtnToggle,VCard,VContainer,VIcon})
